import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ENV from 'tio-employee/config/environment';
import type SessionService from 'tio-employee/services/session';
import type SessionContextService from 'tio-employee/services/session-context';
import { timeZone } from 'tio-common/utils/date/time-zone';
import { generateRequestId } from 'tio-common/utils/request-id';

export default class AuthByTokenRoute extends Route {
  @service declare session: SessionService;
  @service declare sessionContext: SessionContextService;

  async beforeModel() {
    const tokens = Object.fromEntries(new URLSearchParams(location.hash.replace('#', '?')));

    let token = tokens.tio as string;

    const headers = {
      'x-api-key': ENV.apiKey,
      'tio-temp-token': token,
      'Content-Type': 'application/json',
      'Time-Zone': timeZone(),
      'X-Request-Id': generateRequestId(),
    };
    try {
      const response = await fetch(`${ENV.apiHost}/saml/token_exchange`, { headers });
      const { access_token } = await response.json();
      token = access_token;
    } catch (e) {
      console.error('Failed to exchange token:', e);
    }

    await this.session.authenticate('authenticator:saml', { access_token: token });

    await this.sessionContext.load();
  }
}
